import useStoreMonitor from "../warehouse/useStoreMonitor";

let count = 1;

function useMap() {
    const map = new Map(...arguments);
    return map;
}

export default useMap;
